import IconButton from '@mui/material/IconButton';
import MuiTooltip from '@mui/material/Tooltip';
import styled, { css } from 'styled-components';

// import { IconButton } from '@effizency/efz-design-system';
import { themeBase } from 'constants/styles/global';

const iconColor = (type: 'default' | 'warning' | 'error' | 'info' | 'success' | undefined) => {
    switch (type) {
        case 'info':
            // @ts-ignore
            return themeBase.color.info600;
        case 'warning':
            // @ts-ignore
            return themeBase.color.efzLemon600;
        case 'error':
            return themeBase.color.error600;
        case 'success':
            return themeBase.color.success600;
        default:
            // @ts-ignore
            return themeBase.color.info500;
    }
};
const tooltipIconCSS = css`
    padding: 0 !important;
    cursor: help !important;
    pointer-events: auto;

    svg {
        height: 1rem;
        width: 1rem;
        margin: 0.25rem;

        path {
            fill: ${themeBase.color.steel200};
        }
    }
`;
const tooltipArrowColors = (type: 'default' | 'warning' | 'error' | 'info' | 'success' | undefined) => {
    // @ts-ignore
    let arrowBorderColor = `${themeBase.color.neutral400}`;
    let arrowColor = '#ffffff';

    switch (type) {
        case 'default':
            // @ts-ignore
            arrowBorderColor = `${themeBase.color.neutral400}`;
            arrowColor = '#ffffff';
            break;
        case 'info':
            // @ts-ignore
            arrowBorderColor = `${themeBase.color.info600}`;
            // @ts-ignore
            arrowColor = `${themeBase.color.info50}`;
            break;
        case 'warning':
            // @ts-ignore
            arrowBorderColor = `${themeBase.color.efzLemon600}`;
            // @ts-ignore
            arrowColor = `${themeBase.color.efzLemon50}`;
            break;
        case 'error':
            // @ts-ignore
            arrowBorderColor = `${themeBase.color.edpRed500}`;
            // @ts-ignore
            arrowColor = `${themeBase.color.edpRed50}`;
            break;
        case 'success':
            // @ts-ignore
            arrowBorderColor = `${themeBase.color.success600}`;
            // @ts-ignore
            arrowColor = `${themeBase.color.success50}`;
            break;
        default:
            // @ts-ignore
            arrowBorderColor = `${themeBase.color.neutral400}`;
            arrowColor = '#ffffff';
            break;
    }
    return { arrowBorderColor, arrowColor };
};
export const arrowTooltip = (type: 'default' | 'warning' | 'error' | 'info' | 'success' | undefined) => ({
    [`.efz-tooltip-arrow`]: {
        '&-bottom-end, &-bottom-start, &-top-end, &-top-start': {
            '.MuiTooltip-arrow': {
                borderTop: '0.75rem solid transparent !important',
                borderBottom: '0.75rem solid transparent !important',
                overflow: 'visible !important',

                '&::before': {
                    border: 'inherit !important',
                    backgroundColor: 'inherit !important',
                    borderTop: '0.75rem solid transparent !important',
                    borderBottom: '0.75rem solid transparent !important',
                    transform: 'translate(-50%, -50%) !important',
                },
            },
        },

        '&-bottom-end, &-bottom-start': {
            '.MuiTooltip-arrow': {
                marginBottom: '-0.813rem !important',
                bottom: '0 !important',
                top: 'auto !important',

                '&::before': {
                    marginTop: '-0.125rem !important',
                },
            },
        },

        '&-bottom-end, &-top-end': {
            '.MuiTooltip-arrow': {
                borderLeft: '0.75rem solid transparent !important',
                borderRight: `0.75rem solid ${tooltipArrowColors(type).arrowBorderColor} !important`,
                transform: 'translate(1px, 0px) !important',

                '&::before': {
                    borderLeft: '0.75rem solid transparent !important',
                    borderRight: `0.75rem solid ${tooltipArrowColors(type).arrowColor} !important`,
                    marginLeft: '-0.063rem !important',
                },
            },
        },

        '&-bottom-start,  &-top-start': {
            '.MuiTooltip-arrow': {
                borderLeft: `0.75rem solid ${tooltipArrowColors(type).arrowBorderColor} !important`,
                borderRight: '0.75rem solid transparent !important',
                transform: 'translate(-1px, 0px) !important',

                '&::before': {
                    borderLeft: `0.75rem solid ${tooltipArrowColors(type).arrowColor} !important`,
                    borderRight: '0.75rem solid transparent !important',
                    marginLeft: '0.063rem !important',
                },
            },
        },

        '&-top-end,  &-top-start': {
            '.MuiTooltip-arrow': {
                marginTop: '-0.813rem !important',

                '&::before': {
                    marginTop: '0.125rem !important',
                },
            },
        },

        '&-left-end, &-left-start, &-right-start, &-right-end': {
            '.MuiTooltip-arrow': {
                borderLeft: '0.75rem solid transparent !important',
                borderRight: '0.75rem solid transparent !important',
                overflow: 'visible !important',

                '&::before': {
                    border: 'inherit !important',
                    backgroundColor: 'inherit !important',
                    borderLeft: '0.75rem solid transparent !important',
                    borderRight: '0.75rem solid transparent !important',
                    transform: 'translate(-50%, -50%) !important',
                },
            },
        },

        '&-left-end, &-left-start': {
            '.MuiTooltip-arrow::before': {
                marginLeft: '0.125rem !important',
            },
        },

        '&-right-start, &-right-end': {
            '.MuiTooltip-arrow::before': {
                marginLeft: '-0.125rem !important',
            },
        },

        '&-left-end, &-right-end': {
            '.MuiTooltip-arrow': {
                borderTop: '0.75rem solid transparent !important',
                borderBottom: `0.75rem solid ${tooltipArrowColors(type).arrowBorderColor} !important`,
                transform: 'translate(1px, 0px) !important',
                marginBottom: '-0.063rem !important',

                '&::before': {
                    borderTop: '0.75rem solid transparent !important',
                    borderBottom: `0.75rem solid ${tooltipArrowColors(type).arrowColor} !important`,
                    marginTop: '-0.063rem !important',
                },
            },
        },

        '&-left-end': {
            '.MuiTooltip-arrow': {
                marginLeft: '-0.875rem !important',
            },
        },

        '&-right-end': {
            '.MuiTooltip-arrow': {
                marginRight: '-0.75rem !important',
            },
        },

        '&-left-start, &-right-start': {
            '.MuiTooltip-arrow': {
                borderTop: `0.75rem solid ${tooltipArrowColors(type).arrowBorderColor} !important`,
                borderBottom: '0.75rem solid transparent !important',
                transform: 'translate(-1px, 0px) !important',
                marginTop: '-0.063rem !important',

                '&::before': {
                    borderTop: `0.75rem solid ${tooltipArrowColors(type).arrowColor} !important`,
                    borderBottom: '0.75rem solid transparent !important',
                    marginTop: '0.063rem !important',
                },
            },
        },

        '&-left-start': {
            '.MuiTooltip-arrow': {
                marginLeft: '-0.688rem !important',
            },
        },

        '&-right-start': {
            '.MuiTooltip-arrow': {
                marginRight: '-0.875rem !important',
            },
        },

        '&-bottom-end, &-top-end, &-right-end, &-right-start': {
            '.MuiTooltip-arrow': {
                right: '0px !important',
                left: 'auto !important',
            },
        },

        '&-left-start, &-left-end, &-top-start, &-bottom-start': {
            '.MuiTooltip-arrow': {
                right: 'auto !important',
                left: '0px !important',
            },
        },

        '&-top-start, &-bottom-start': {
            '.MuiTooltip-arrow': {
                marginLeft: '0px !important',
            },
        },

        '&-bottom-end, &-bottom-start, &-right-end, &-left-end': {
            '.MuiTooltip-arrow': {
                bottom: '0px !important',
                top: 'auto !important',
            },
        },

        '&-left-start, &-right-start, &-top-start, &-top-end': {
            '.MuiTooltip-arrow': {
                bottom: 'auto !important',
                top: '0px !important',
            },
        },
    },
});
interface StyledTooltipProps {
    $type?: 'default' | 'warning' | 'error' | 'info' | 'success';
}

export const StyledTooltip = styled(MuiTooltip).attrs<StyledTooltipProps>((props: StyledTooltipProps) => ({
    $type: props?.$type ?? 'info',
}))<StyledTooltipProps>`
    div.MuiTooltip-tooltip {
        padding: 0 !important;
    }

    .efz-tooltip-content {
        font-size: 0.75rem;
        // @ts-ignore
        color: ${themeBase.color.steel800};
        padding: 8px;
        text-align: center;

        p,
        ul {
            margin-top: 0;
            margin-bottom: 0;
        }

        .link {
            // @ts-ignore
            color: ${themeBase.color.info600};
            text-decoration: underline;
            cursor: pointer;
        }
    }

    .efz-tooltip-default {
        div.MuiTooltip-tooltip {
            background-color: #ffffff !important;
            // @ts-ignore
            border: 1px solid ${themeBase.color.steel400};
        }

        .MuiTooltip-arrow::before {
            background-color: #ffffff !important;
            // @ts-ignore
            border: 1px solid ${themeBase.color.steel400};
        }
    }

    .efz-tooltip-info {
        div.MuiTooltip-tooltip {
            background-color: ${themeBase.color.info500} !important;
            border: 1px solid ${themeBase.color.info600};
        }

        .MuiTooltip-arrow::before {
            background-color: ${themeBase.color.info500} !important;
            border: 1px solid ${themeBase.color.info600};
        }
    }

    .efz-tooltip-warning {
        div.MuiTooltip-tooltip {
            background-color: ${themeBase.color.efzLemon500} !important;
            border: 1px solid ${themeBase.color.efzLemon600};
        }

        .MuiTooltip-arrow::before {
            background-color: ${themeBase.color.efzLemon500} !important;
            border: 1px solid ${themeBase.color.efzLemon600};
        }
    }

    .efz-tooltip-error {
        div.MuiTooltip-tooltip {
            background-color: ${themeBase.color.error500} !important;
            border: 1px solid ${themeBase.color.error600};
        }

        .MuiTooltip-arrow::before {
            background-color: ${themeBase.color.error500} !important;
            border: 1px solid ${themeBase.color.error600};
        }
    }

    .efz-tooltip-success {
        div.MuiTooltip-tooltip {
            background-color: ${themeBase.color.success500} !important;
            border: 1px solid ${themeBase.color.success600};
        }

        .MuiTooltip-arrow::before {
            background-color: ${themeBase.color.success500} !important;
            border: 1px solid ${themeBase.color.success600};
        }
    }
`;

interface StyledTooltipIconProps {
    $type?: 'default' | 'warning' | 'error' | 'info' | 'success';
}

export const StyledTooltipIcon = styled(IconButton).attrs<StyledTooltipIconProps>((props: StyledTooltipIconProps) => ({
    $type: props?.$type ?? 'info',
}))<StyledTooltipIconProps>`
    ${tooltipIconCSS};
    &.hovered {
        svg {
            path {
                fill: ${(props: StyledTooltipIconProps) => iconColor(props.$type)};
            }
        }
    }

    &:hover {
        svg {
            path {
                fill: ${(props: StyledTooltipIconProps) => iconColor(props.$type)};
            }
        }
    }
`;
